<template>
  <div :class="{ [$style.container]: !boundless, [$style.containerBg]: background }">
    <v-grid :in="cols" v-if="has('header')">
      <v-row v-if="arrowCollapsable">
        <v-col :has="cols - 2" off="1">
          <div class="out-left" :class="[{ 'out-right': !collapsable }, $style.containerInnerPadded]">
            <v-row>
              <v-col has="1">
                <button type="button" class="mt-link" :class="$style.collapseButton" @click="toggleOpen">
                  <span class="mt-icon" :class="collapseIcon" />
                </button>
              </v-col>
              <v-col has="11">
                <slot name="header" />
              </v-col>
            </v-row>
          </div>
        </v-col>
      </v-row>
      <v-row v-else :class="(activePromo || scheduledPromo || pastPromo) && $style.paddingLeftRight">
        <v-col :has="cols - 2" :off="activePromo || scheduledPromo || pastPromo ? 0 : 1">
          <div
            :class="[
              { 'out-right': !(collapsable || activePromo || scheduledPromo || pastPromo) },
              { 'out-left': !(activePromo || scheduledPromo || pastPromo) },
              $style.containerInnerPadded
            ]"
          >
            <slot name="header" />
          </div>
        </v-col>
        <v-col v-if="collapsable" has="1" :class="$style.collapse">
          <div class="out-left">
            <button type="button" class="mt-link" :class="$style.collapseButton" @click="toggleOpen">
              {{ collapseText }}
            </button>
          </div>
        </v-col>
        <v-col v-if="activePromo" has="2" :class="$style.promoStatusBtn">
          <div class="mt-serif" :class="$style.activePromoStatus">
            {{ active }}
          </div>
        </v-col>
        <v-col v-if="scheduledPromo" has="2" :class="$style.promoStatusBtn">
          <div class="mt-serif" :class="$style.scheduledPromoStatus">
            {{ scheduled }}
          </div>
        </v-col>
        <v-col v-if="pastPromo" has="2" :class="$style.promoStatusBtn">
          <div class="mt-serif" :class="$style.pastPromoStatus">Completed</div>
        </v-col>
      </v-row>
    </v-grid>

    <transition-slide name="fade" v-if="has('header') && has('content')">
      <div v-show="isOpen" :class="$style.contentBorder" />
    </transition-slide>

    <transition-slide :open="collapsed">
      <div v-if="isOpen" :class="contentClass">
        <slot name="content" />
      </div>
    </transition-slide>
  </div>
</template>

<script type="text/ecmascript-6">
import TransitionSlide from 'components/transitions/slide-transition/'
import FouGrid from 'src/components/layout/fou-grid/'

export default {
  name: 'FouContainer',

  components: {
    TransitionSlide,
    ...FouGrid
  },

  props: {
    cols: {
      type: [String, Number],
      default: 3 // Mininum
    },
    arrowCollapsable: {
      type: Boolean,
      default: false
    },
    collapsable: {
      type: Boolean,
      default: false
    },
    activePromo: {
      type: Boolean,
      default: false
    },
    scheduledPromo: {
      type: Boolean,
      default: false
    },
    pastPromo: {
      type: Boolean,
      default: false
    },
    collapsed: {
      type: Boolean,
      default: false
    },
    boundless: {
      type: Boolean,
      default: false
    },
    background: {
      type: Boolean,
      default: false
    },
    padded: {
      type: Boolean,
      default: false
     },
  },

  data () {
    return {
      isOpen: true,
      active: 'Active',
      scheduled: 'Scheduled',
    }
  },

  computed: {
    collapseText () {
      return this.isOpen
        ? 'Collapse'
        : 'Expand'
    },
    collapseIcon () {
      return this.isOpen
        ? 'mt-icon-arrow-simple-up'
        : 'mt-icon-arrow-simple-down'
    },
    contentClass () {
      return this.padded
        ? this.$style.contentPadded
        : ''
    }
  },

  created () {
    this.isOpen = !this.collapsed;
  },

  methods: {
    toggleOpen() {
      this.isOpen = !this.isOpen
    },
    has(slot) {
      return typeof this.$slots[slot]?.() === 'object'
    }
  }
}
</script>

<style lang="scss" module>
@import 'mpl-css/lib/assets/global/variables/colors';
@import 'mpl-css/lib/assets/global/variables/layout';
@import 'mpl-css/lib/assets/global/functions/index';

.container {
  border: 1px solid map-get($colors, 'grey');
  box-shadow: 0 2px 2px 0 rgba(map-get($colors, 'grey'), 0.6);
}
.containerBg {
  background: map-get($colors, 'white');
}
.collapse {
  display: flex;
  align-items: center;
}
.promoStatusBtn {
  display: flex;
  align-items: center;
  justify-content: end;
}
.collapseButton {
  text-decoration: none;
}
.containerInnerPadded {
  padding: rem($layout-vertical-unit * 2) 0;
  position: relative;
}
.contentBorder {
  border-top: 1px solid map-get($colors, 'grey');
}
.contentPadded {
  padding-top: rem($layout-vertical-unit * 4);
  padding-bottom: rem($layout-vertical-unit * 4);
}
.activePromoStatus {
  font-size: 16px;
  line-height: 30px;
  padding-left: 10px;
  padding-right: 10px;
  color: #ffffff;
  border: 1px solid #26a568;
  border-radius: 3px;
  background-color: #26a568;
}
.scheduledPromoStatus {
  font-size: 16px;
  line-height: 30px;
  padding-left: 10px;
  padding-right: 10px;
  color: #26a568;
  border: 1px solid #26a568;
  border-radius: 3px;
  background-color: #ffffff;
}
.pastPromoStatus {
  font-size: 16px;
  line-height: 30px;
  padding-left: 10px;
  padding-right: 10px;
  color: #9ea6ac;
  border: 1px solid #9ea6ac;
  border-radius: 3px;
  background-color: #ffffff;
}
.paddingLeftRight {
  padding: 0 48px;
}
</style>
